module.exports = __webpack_public_path__ + "static/img/moistures.5e8d2b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moistures.png
// module id = jscj
// module chunks = 0